/**
 * ULTALIFE Homepage Scroll-Reveal Animations
 * Targets all custom section classes found in the live DOM.
 * Uses IntersectionObserver for performance — no layout thrashing.
 */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;

  /* ─── CSS injected once ─────────────────────────────────────── */
  var style = document.createElement('style');
  style.textContent = [
    /* Base hidden state */
    '.ul-reveal { opacity: 0; transform: translateY(32px); transition: opacity 0.7s cubic-bezier(.22,1,.36,1), transform 0.7s cubic-bezier(.22,1,.36,1); }',
    '.ul-reveal.ul-revealed { opacity: 1; transform: translateY(0); }',

    /* Stagger delays for grid children */
    '.ul-reveal-child { opacity: 0; transform: translateY(28px); transition: opacity 0.65s cubic-bezier(.22,1,.36,1), transform 0.65s cubic-bezier(.22,1,.36,1); }',
    '.ul-reveal-child.ul-revealed { opacity: 1; transform: translateY(0); }',
    '.ul-reveal-child:nth-child(1) { transition-delay: 0.05s; }',
    '.ul-reveal-child:nth-child(2) { transition-delay: 0.15s; }',
    '.ul-reveal-child:nth-child(3) { transition-delay: 0.25s; }',
    '.ul-reveal-child:nth-child(4) { transition-delay: 0.35s; }',
    '.ul-reveal-child:nth-child(5) { transition-delay: 0.45s; }',
    '.ul-reveal-child:nth-child(6) { transition-delay: 0.55s; }',

    /* Slide-in from left */
    '.ul-reveal-left { opacity: 0; transform: translateX(-40px); transition: opacity 0.75s cubic-bezier(.22,1,.36,1), transform 0.75s cubic-bezier(.22,1,.36,1); }',
    '.ul-reveal-left.ul-revealed { opacity: 1; transform: translateX(0); }',

    /* Slide-in from right */
    '.ul-reveal-right { opacity: 0; transform: translateX(40px); transition: opacity 0.75s cubic-bezier(.22,1,.36,1), transform 0.75s cubic-bezier(.22,1,.36,1); }',
    '.ul-reveal-right.ul-revealed { opacity: 1; transform: translateX(0); }',

    /* Scale in */
    '.ul-reveal-scale { opacity: 0; transform: scale(0.94); transition: opacity 0.7s cubic-bezier(.22,1,.36,1), transform 0.7s cubic-bezier(.22,1,.36,1); }',
    '.ul-reveal-scale.ul-revealed { opacity: 1; transform: scale(1); }',

    /* Respect reduced motion */
    '@media (prefers-reduced-motion: reduce) {',
    '  .ul-reveal, .ul-reveal-child, .ul-reveal-left, .ul-reveal-right, .ul-reveal-scale {',
    '    opacity: 1 !important; transform: none !important; transition: none !important;',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  /* ─── Observer factory ──────────────────────────────────────── */
  function makeObserver(threshold) {
    return new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ul-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: threshold || 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  var obs = makeObserver(0.12);
  var obsEarly = makeObserver(0.05); // for tall sections

  /* ─── Helper: add class + observe ──────────────────────────── */
  function reveal(el, cls, observer) {
    if (!el || el.classList.contains('ul-reveal') || el.classList.contains('ul-reveal-child')) return;
    el.classList.add(cls || 'ul-reveal');
    (observer || obs).observe(el);
  }

  function revealChildren(parent, selector, observer) {
    if (!parent) return;
    var children = parent.querySelectorAll(selector);
    children.forEach(function (child) {
      child.classList.add('ul-reveal-child');
      (observer || obs).observe(child);
    });
  }

  /* ─── Wire up each section ──────────────────────────────────── */
  function init() {

    /* ── TRUTH SECTION ── */
    var truth = document.querySelector('.ult-truth');
    if (truth) {
      reveal(truth.querySelector('.ult-truth__copy'), 'ul-reveal-left');
      revealChildren(truth, '.ult-truth__term');
    }

    /* ── GOAL CARDS ── */
    var goals = document.querySelector('.ul-goal-section');
    if (goals) {
      reveal(goals.querySelector('.ul-goal-header'), 'ul-reveal');
      revealChildren(goals, '.ul-goal-card');
    }

    /* ── DOSAGE BARS ── */
    var dosage = document.querySelector('.ul-dosage-section');
    if (dosage) {
      reveal(dosage.querySelector('.ul-dosage-header'), 'ul-reveal');
      reveal(dosage.querySelector('.ul-dosage-legend'), 'ul-reveal');
      // Chart container fades in after header
      var chart = dosage.querySelector('.ul-dosage-chart, [class*="dosage-chart"], [class*="dosage-bars"]');
      if (chart) reveal(chart, 'ul-reveal');
    }

    /* ── PRODUCT CARDS ── */
    var pcards = document.querySelector('.ul-pc-section');
    if (pcards) {
      reveal(pcards.querySelector('.ul-pc-header'), 'ul-reveal');
      revealChildren(pcards, '.ul-pcard');
    }

    /* ── FOUNDER ── */
    var founder = document.querySelector('.ul-founder-section');
    if (founder) {
      reveal(founder.querySelector('.ul-founder-photo'), 'ul-reveal-left', obsEarly);
      reveal(founder.querySelector('.ul-founder-copy'), 'ul-reveal-right', obsEarly);
    }

    /* ── REVIEWS ── */
    var reviews = document.querySelector('.ul-reviews-section');
    if (reviews) {
      reveal(reviews.querySelector('.ul-reviews-header'), 'ul-reveal');
      revealChildren(reviews, '.ul-review-card');
    }

    /* ── COMPARISON TABLE ── */
    var compare = document.querySelector('.ul-compare-section');
    if (compare) {
      reveal(compare.querySelector('.ul-compare-header'), 'ul-reveal');
      reveal(compare.querySelector('.ul-compare-table'), 'ul-reveal-scale');
    }

    /* ── OPT-IN / EMAIL CAPTURE ── */
    var optin = document.querySelector('.ul-optin-section, [class*="optin"]');
    if (optin) {
      reveal(optin, 'ul-reveal-scale');
    }

    /* ── BOTTLE SHOWCASE (if present) ── */
    var showcase = document.querySelector('#ul-bottle-showcase');
    if (showcase) {
      reveal(showcase.querySelector('.ul-bs-header'), 'ul-reveal');
      revealChildren(showcase, '.ul-bottle-item');
    }
  }

  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
